/**
 * @generated SignedSource<<aeed1b5774f1d2d090cc90a9430d25e5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ActionItemGroupsListMoveActionItemsMutation$variables = {
  groupId: string;
  includeAiDetected?: boolean | null;
  includeCompleted?: boolean | null;
  includeWontDo?: boolean | null;
  noteBlockIds: ReadonlyArray<string>;
  orderInsertedAfter?: string | null;
  orderInsertedBefore?: string | null;
};
export type ActionItemGroupsListMoveActionItemsMutation$data = {
  readonly moveActionItemsToGroup: {
    readonly actionItemGroups: ReadonlyArray<{
      readonly id: string;
      readonly items: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly id: string;
          };
        } | null>;
      };
    }> | null;
    readonly updatedBlocks: ReadonlyArray<{
      readonly id: string;
      readonly userOrderWithinGroup: string | null;
    }>;
  } | null;
};
export type ActionItemGroupsListMoveActionItemsMutation$rawResponse = {
  readonly moveActionItemsToGroup: {
    readonly actionItemGroups: ReadonlyArray<{
      readonly id: string;
      readonly items: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly id: string;
          };
        } | null>;
      };
    }> | null;
    readonly updatedBlocks: ReadonlyArray<{
      readonly id: string;
      readonly userOrderWithinGroup: string | null;
    }>;
  } | null;
};
export type ActionItemGroupsListMoveActionItemsMutation = {
  rawResponse: ActionItemGroupsListMoveActionItemsMutation$rawResponse;
  response: ActionItemGroupsListMoveActionItemsMutation$data;
  variables: ActionItemGroupsListMoveActionItemsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "groupId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeAiDetected"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeCompleted"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeWontDo"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "noteBlockIds"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "orderInsertedAfter"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "orderInsertedBefore"
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v8 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "groupId",
        "variableName": "groupId"
      },
      {
        "kind": "Variable",
        "name": "noteBlockIds",
        "variableName": "noteBlockIds"
      },
      {
        "kind": "Variable",
        "name": "orderInsertedAfter",
        "variableName": "orderInsertedAfter"
      },
      {
        "kind": "Variable",
        "name": "orderInsertedBefore",
        "variableName": "orderInsertedBefore"
      }
    ],
    "concreteType": "MoveActionItemsToGroup",
    "kind": "LinkedField",
    "name": "moveActionItemsToGroup",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "NoteBlock",
        "kind": "LinkedField",
        "name": "updatedBlocks",
        "plural": true,
        "selections": [
          (v7/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "userOrderWithinGroup",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ActionItemGroupNode",
        "kind": "LinkedField",
        "name": "actionItemGroups",
        "plural": true,
        "selections": [
          (v7/*: any*/),
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "includeAiDetected",
                "variableName": "includeAiDetected"
              },
              {
                "kind": "Variable",
                "name": "includeCompleted",
                "variableName": "includeCompleted"
              },
              {
                "kind": "Variable",
                "name": "includeWontDo",
                "variableName": "includeWontDo"
              }
            ],
            "concreteType": "ActionItemGroupNoteBlockConnection",
            "kind": "LinkedField",
            "name": "items",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ActionItemGroupNoteBlockEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "NoteBlock",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ActionItemGroupsListMoveActionItemsMutation",
    "selections": (v8/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v4/*: any*/),
      (v0/*: any*/),
      (v6/*: any*/),
      (v5/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "ActionItemGroupsListMoveActionItemsMutation",
    "selections": (v8/*: any*/)
  },
  "params": {
    "cacheID": "5ea47c5c58ce09ea482e4851a54ec52d",
    "id": null,
    "metadata": {},
    "name": "ActionItemGroupsListMoveActionItemsMutation",
    "operationKind": "mutation",
    "text": "mutation ActionItemGroupsListMoveActionItemsMutation(\n  $noteBlockIds: [ID!]!\n  $groupId: ID!\n  $orderInsertedBefore: String\n  $orderInsertedAfter: String\n  $includeCompleted: Boolean\n  $includeWontDo: Boolean\n  $includeAiDetected: Boolean\n) {\n  moveActionItemsToGroup(noteBlockIds: $noteBlockIds, groupId: $groupId, orderInsertedBefore: $orderInsertedBefore, orderInsertedAfter: $orderInsertedAfter) {\n    updatedBlocks {\n      id\n      userOrderWithinGroup\n    }\n    actionItemGroups {\n      id\n      items(includeCompleted: $includeCompleted, includeWontDo: $includeWontDo, includeAiDetected: $includeAiDetected) {\n        edges {\n          node {\n            id\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "4aaaf912d730602c0e1b24a27e4983d4";

export default node;
